export const borderRadius = {
  xs: '2px',
  sm: '4px',
  md: '8px',
  lg: '16px',
  xl: '24px',
  xxl: '48px',
  circle: '50%',
} as const
